module.exports = __webpack_public_path__ + "static/media/Fusion 360 Manage.8ddfbb16.png";